// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"416":"8b380ac869f398c4","629":"2ece6f66a5c259f8"}[chunkId] + ".css";
};